import React from "react";
import { CHART_COLORS } from "@/features/investors/components/charts/palette";

export type HBarItem = {
    label: string;
    value: number;
    color?: string;
    sub?: string;
};

type Props = {
    items: HBarItem[];
    color?: string;
    max?: number;
    formatValue: (value: number) => string;
};

export const HBars: React.FC<Props> = ({ items, color = CHART_COLORS.blue, max, formatValue }) => {
    if (items.length === 0) return null;
    const limit = max !== undefined ? max : Math.max(...items.map((item) => item.value)) || 1;

    return (
        <div className="hbars">
            {items.map((item) => {
                const width = limit === 0 ? 0 : (item.value / limit) * 100;
                const fill = item.color !== undefined ? item.color : color;
                const tip = `<b>${item.label}</b><br>${formatValue(item.value)}${item.sub !== undefined ? `<br>${item.sub}` : ""}`;
                return (
                    <div key={item.label} className="hbar-row" data-tip={tip}>
                        <div className="hbar-lab">{item.label}</div>
                        <div className="hbar-track">
                            <div
                                className="hbar-fill"
                                style={{ width: `${width.toFixed(1)}%`, background: fill }}
                            />
                        </div>
                        <div className="hbar-val">{formatValue(item.value)}</div>
                    </div>
                );
            })}
        </div>
    );
};
